export default {
  name: "footerSection"
};
